import { InMemoryCache, InMemoryCacheConfig } from '@apollo/client';
import { porpaginasOffsetPolicy } from './porpaginasOffsetPolicy';
import { workspaceCategoriesPolicy } from './workspaceCategoriesPolicy';
import { findImagesSearchMergePolicy, mediaLibraryMergePolicy } from './mediaLibraryMergePolicy';
import { postScheduleMergePolicy } from './postScheduleMergePolicy';
import { thirdPartyPostPolicy } from './thirdPartyPostPolicy';
import { queueCountsPolicy } from './queueCountsPolicy';
import { socialProfilesPolicy } from './socialProfilesPolicy';
import { autoImportsPolicy } from './autoImportsPolicy';
import { linksMetadataMergePolicy } from './linksMetadataMergePolicy';

export const cacheConfig: InMemoryCacheConfig = {
  possibleTypes: {
    SocialProfileInterface: [
      'InstagramSocialProfile',
      'FacebookSocialProfile',
      'LinkedInSocialProfile',
      'TikTokSocialProfile',
      'TwitterSocialProfile',
      'PinterestSocialProfile',
      'GoogleSocialProfile',
      'GenericSocialProfile'
    ],
    MediaInterface: ['Photo', 'Video'],
    MobileApp: ['IosApp', 'AndroidApp'],
    PlanUsageType: ['posts', 'socialProfiles', 'activeCategories', 'autoImports', 'importSources']
  },
  typePolicies: {
    Query: {
      fields: {
        searchPixabay: findImagesSearchMergePolicy(),
        searchGiphy: findImagesSearchMergePolicy(),
        searchUnsplash: findImagesSearchMergePolicy(),
        searchFacebookPosts: thirdPartyPostPolicy(),
        searchInstagramPosts: thirdPartyPostPolicy(),
        searchLinkedInPosts: thirdPartyPostPolicy(),
        searchPinterestPosts: thirdPartyPostPolicy(),
        searchTwitterPosts: thirdPartyPostPolicy(),
        searchRssPosts: thirdPartyPostPolicy(),
        linkMetadata: linksMetadataMergePolicy()
      }
    },
    QueueMetadata: {
      keyFields: ['socialProfile', 'category']
    },
    Workspace: {
      fields: {
        categories: workspaceCategoriesPolicy(),
        mediaLibrary: mediaLibraryMergePolicy(),
        queue: postScheduleMergePolicy(),
        queueCounts: queueCountsPolicy(),
        socialProfiles: socialProfilesPolicy(),
        autoImports: autoImportsPolicy()
      }
    },
    Timeslot: {
      fields: {
        socialProfiles: {
          merge: false
        }
      }
    },
    PorpaginasResult_Notification: {
      fields: {
        items: porpaginasOffsetPolicy()
      }
    },
    ThirdPartyProfile: {
      keyFields: ['externalId', 'platform']
    },
    LinkMetadata: {
      keyFields: ['initialUrl']
    },
    PlanUsageType: {
      keyFields: []
    },
    SocialProfileInterface: {
      fields: {
        photoUrlFetched: {
          read(existing = false) {
            return existing;
          }
        }
      }
    },
    UserOnboardingStep: {
      keyFields: ['name']
    }
  }
};

const cache: InMemoryCache = new InMemoryCache(cacheConfig);
export const getCache = (): InMemoryCache => {
  return cache || new InMemoryCache(cacheConfig);
};
